<div class="modal top-modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle}">
    <div class="modal-dialog" role="document">
        <div class="modal-content popup-bg">
            <div class="modal-body">

                <!--Upon entering the Game after claiming the Promotion-->
                <ng-container *ngIf="data && data.PPPhase1 == true && promoPP.p1PopSeen == false">
                    <div class="w-100 custom-padding">
                        <h3 class="popup-title m-auto w-75 ">{{ 'Reminder' | translate | uppercase }}</h3>
                        <p class="popup-content w-100 m-b-10">
                            {{ "You're entering Free Spins Mode." | translate}} 
                        </p>
                        <p class="popup-content w-100">
                            {{ "No deposit allowed. Win" | translate }}&nbsp;{{ userData.currency.code }} {{ promoPP.p1TargetAmount | number: '1.2-2' }}&nbsp;{{"or more to qualify for the next round!" | translate}}
                        </p>
                        <div class="col-4 m-b-20 m-auto">
                            <div class="amount-container">
                                <div class="coin-icon">
                                    <img src="/assets/images/coin.png"/>
                                </div>
                                <span>{{ promoPP.p1TargetAmount | number: '1.2-2'}}</span>
                            </div>
                        </div>
                        <button type="button" class="btn btn-lg start_button col-10 w-100 m-b-15" (click)="launchGame()" >{{ "Start Free Spin" | translate | uppercase }}</button>
                    </div>
                </ng-container>
                <!--End of Upon entering the Game after claiming the Promotion-->

                <!--Upon entering the Game after claiming the BTG Promotion-->
                <ng-container *ngIf="data && data.BTGPhase1 == true && promoBTG.p1PopSeen == false">
                    <div class="w-100 custom-padding">
                        <h3 class="popup-title m-auto w-75 ">{{ 'Reminder' | translate | uppercase }}</h3>
                        <p class="popup-content w-100 m-b-10">
                            {{ "You're entering Free Credits Mode." | translate}} 
                        </p>
                        <p class="popup-content w-100">
                            {{ "No deposit allowed. Win" | translate }}&nbsp;{{ userData.currency.code }} {{ promoBTG.p1TargetAmount | number: '1.2-2' }}&nbsp;{{"or more to qualify for the next round!" | translate}}
                        </p>
                        <div class="col-4 m-b-20 m-auto">
                            <div class="amount-container">
                                <div class="coin-icon">
                                    <img src="/assets/images/coin.png"/>
                                </div>
                                <span>{{ promoBTG.p1TargetAmount | number: '1.2-2'}}</span>
                            </div>
                        </div>
                        <button type="button" class="btn btn-lg start_button col-10 w-100 m-b-15" (click)="launchGame()" >{{ "Start Free Credit" | translate | uppercase }}</button>
                    </div>
                </ng-container>
                <!--End of Upon entering the Game after claiming the Promotion-->

                <!--After Phase 1 (Win Condition)-->
                <ng-container *ngIf="data.Phase1WinLose == 1 && (promoPP.p1ResPopSeen == false || promoBTG.p1ResPopSeen == false)">
                    <div class="w-100 custom-padding m-t-0">
                        <div>
                            <div class="win-icon-wrapper">
                                <img src="/assets/images/win-bg.png" class="win-bg" />
                                <img src="/assets/images/win.png" class="trophy-icon" />
                            </div>
                        </div>
                        <h3 class="popup-title winlose-title m-auto w-75 ">{{ 'Congratulations!' | translate | uppercase }}</h3>
                        <p class="winlose-content w-100 m-b-20">
                            {{ "You nailed it with" | translate }}&nbsp;{{ userData.currency.code }} {{ data.p1AccumulatedAmount | number: '1.2-2' }}&nbsp;—&nbsp;{{"Round 2 unlocked!" | translate}} 
                        </p>
                        <button type="button" class="btn btn-lg start_button col-10 w-100 m-b-15" (click)="proceedToP2(true)" >{{ "Proceed" | translate | uppercase }}</button>
                    </div>
                </ng-container>
                <!-- End of After Phase 1 (Win Condition)-->

                <!--After Phase 1 (Lose Condition)-->
                <ng-container *ngIf="data.Phase1WinLose != undefined && data.Phase1WinLose == 0 && (promoPP.p1ResPopSeen == false || promoBTG.p1ResPopSeen == false)">
                    <div class="w-100 custom-padding m-t-0">
                    <div class="col-3 m-t-10 m-auto">
                        <div class="four-leaf-clover-icon">
                            <img src="/assets/images/four-leaf-clover.png"/>
                        </div>
                    </div>
                    <h3 class="popup-title winlose-title m-auto w-75 ">{{ 'Almost there!' | translate | uppercase }}</h3>
                    <p class="winlose-content w-100 m-b-20">
                        {{ "New chances unlock daily — come back stronger!" | translate}} 
                    </p>
                    <button type="button" class="btn btn-lg start_button col-10 w-100 m-b-15" (click)="proceedToP2(false)" >{{ "Close" | translate | uppercase }}</button>
                    </div>
                </ng-container>
                <!-- End of After Phase 1 (Lose Condition)-->

                <!-- Phase 2 -->
                 <ng-container *ngIf="data.PPPhase2 == true && promoPP.p1ResPopSeen == true && promoPP.p2PopSeen == false">
                    <div class="w-100 custom-padding">
                        <h3 class="popup-title m-auto w-75 ">{{ 'Round 2' | translate | uppercase }}</h3>
                        <p class="popup-content w-100 m-b-10">
                            {{ "Your Pragmatic Play balance has been reset to" }}&nbsp;{{ userData.currency.symbol }} {{ promoPP.p2BonusAmount | number: '1.2-2' }}&nbsp;{{". To unlock your winnings, hit a"}}&nbsp;{{ promoPP.p2TargetType }}&nbsp;{{"of"}}&nbsp;{{ userData.currency.symbol }} {{ promoPP.p2TargetAmount | number: '1.2-2' }}&nbsp;{{ "!" | translate }} 
                        </p>
                        <p class="popup-content w-100">
                            {{ "Keep Rolling - Your Luck is HOT!" | translate}}
                        </p>
                        <div class="row m-auto justify-content-center">
                            <div class="col-4 m-b-20">
                                <div class="amount-container">
                                    <div class="coin-icon">
                                        <img src="/assets/images/coin-2.png"/>
                                    </div>
                                    <span>{{ promoPP.p2BonusAmount | number: '1.2-2' }}</span>
                                </div>
                            </div>
                            <div class="col-4 m-b-20">
                                <div class="amount-container">
                                    <div class="coin-icon">
                                        <img src="/assets/images/coin.png"/>
                                    </div>
                                    <span>{{ promoPP.p2TargetAmount | number: '1.2-2' }}</span>
                                </div>
                            </div>
                        </div>
                        <button type="button" class="btn btn-lg start_button col-10 w-100 m-b-15" (click)="closePopup()" >{{ "Got it" | translate | uppercase }}</button>
                    </div>
                </ng-container>
                <!-- End of Upon entering the Game after claiming the Promotion-->

                <!-- BTG Phase 2 -->
                <ng-container *ngIf="data.BTGPhase2 == true && promoBTG.p1ResPopSeen == true && promoBTG.p2PopSeen == false">
                    <div class="w-100 custom-padding">
                        <h3 class="popup-title m-auto w-75 ">{{ 'Round 2' | translate | uppercase }}</h3>
                        <p class="popup-content w-100 m-b-10">
                            {{ "Your BT Gaming balance has been reset to" | translate }}&nbsp;{{ userData.currency.code }} {{ promoBTG.p2BonusAmount | number: '1.2-2' }}&nbsp;.&nbsp;{{"To unlock your winnings, hit a turnover of" | translate }}&nbsp;{{ userData.currency.code }} {{ promoBTG.p2TargetAmount | number: '1.2-2' }}&nbsp;{{ "!" | translate }} 
                        </p>
                        <p class="popup-content w-100">
                            {{ "Keep Rolling - Your Luck is HOT!" | translate}}
                        </p>
                        <div class="row m-auto justify-content-center">
                            <div class="col-4 m-b-20">
                                <div class="amount-container">
                                    <div class="coin-icon">
                                        <img src="/assets/images/coin-2.png"/>
                                    </div>
                                    <span>{{ promoBTG.p2BonusAmount | number: '1.2-2' }}</span>
                                </div>
                            </div>
                            <div class="col-4 m-b-20">
                                <div class="amount-container">
                                    <div class="coin-icon">
                                        <img src="/assets/images/coin.png"/>
                                    </div>
                                    <span>{{ promoBTG.p2TargetAmount | number: '1.2-2' }}</span>
                                </div>
                            </div>
                        </div>
                        <button type="button" class="btn btn-lg start_button col-10 w-100 m-b-15" (click)="closePopup()" >{{ "Got it" | translate | uppercase }}</button>
                    </div>
                </ng-container>
                <!-- End of Upon entering the Game after claiming the Promotion-->
            </div>
        </div>
    </div>
</div>